/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import '../../../styles/tailwind-global.css';
import SEO from "../../../components/seo";
import ComeFunziona from "../common/views/come-funziona";
import Footer from "../../../views/footer";
import * as s from "./index.module.css"
import { addGTMDataLayerToWindow, addGTMEventToWindow } from '../../../utils/gtm-helpers'
import CookieConsentBox from "../../../components/cookie-consent-box";
import Vantaggi from "./views/vantaggi";
import Partner from "./views/partner";
import HeaderTinaba from "../../../views/header-tinaba";
import HeroImage from "./views/hero-image";
import Marquee from "./views/marquee";
import Products from "./views/products";
import ModalAttivaTinaba from "./views/modal-attiva-tinaba";
import ModalInfoPrezzo from "./views/modal-info-prezzo";
import { Helmet } from "react-helmet";

const Base = ({ pageContext: { project } }) => {

    const [isModalAttivaTinabaVisible, setIsModalAttivaTinabaVisible] = useState(false);
    const [isModalInfoPrezzoVisible, setIsModalInfoPrezzoVisible] = useState(false);
    const [isBaseDivLocked, setIsBaseDivLocked] = useState(false);

    useEffect(() => {
        setIsBaseDivLocked(isModalAttivaTinabaVisible || isModalInfoPrezzoVisible);
    }, [isModalAttivaTinabaVisible, isModalInfoPrezzoVisible])

    useEffect(() => {
        addGTMDataLayerToWindow(project, "Landing", "Store Influencer", `Influencer ${project.__influencerName}`);

    }, []);

    return (
        <>

            <Helmet>
                <body className={isBaseDivLocked ? 'no-scroll' : ''} />

                <style type="text/css">{`
                    body.no-scroll {
                        overflow-y: hidden
                    }
                `}</style>
            </Helmet>

            <SEO meta={project.__metaTags} />

            <HeaderTinaba project={project} />

            <HeroImage project={project} />

            <Marquee project={project} />

            <Products project={project} onPrezzoClick={(isTinaba, type, item) => {
                if (isTinaba) {
                    if (type === 'product') {
                        addGTMEventToWindow(project, "priceTinabaClick", { price: item.price })
                    }
                    setIsModalAttivaTinabaVisible(true);
                }
                else {
                    if (type === 'product') {
                        addGTMEventToWindow(project, "priceNormalClick", { price: item.price })
                    }
                    setIsModalInfoPrezzoVisible(true);
                }


            }} />

            <div style={{ height: '60px' }}></div>

            {/*
            <ButtonCTA project={project} />
            */}

            {project.__youtubeVideo && <ComeFunziona project={project} />}

            <Vantaggi project={project} />

            <Partner project={project} />

            <div className={s.footer}>
                <Footer project={project} />
            </div>

            <ModalAttivaTinaba project={project} visible={isModalAttivaTinabaVisible} requestClose={() => { setIsModalAttivaTinabaVisible(false) }} goNext={() => {
                setIsModalAttivaTinabaVisible(false);
                setTimeout(() => {
                    // submitForm();
                }, 500);
            }} />

            <ModalInfoPrezzo project={project} visible={isModalInfoPrezzoVisible} requestClose={() => { setIsModalInfoPrezzoVisible(false) }} goNext={() => {
                setIsModalInfoPrezzoVisible(false);
                setTimeout(() => {
                    // submitForm();
                }, 500);
            }} />

            {/* <CookieConsentBox /> */}
        </>
    )
}


export default Base
